import API, { API_URL } from 'api/API';

import { ApiResult } from 'libs/types';

interface GetServerTimeApiResult extends ApiResult {
  date: string;
  time: string;
}

async function getServerTimeApi(): Promise<GetServerTimeApiResult> {
  const { data } = await API.get(`${API_URL.COMMON.GET_SERVER_TIME}`);

  return data;
}

export default getServerTimeApi;
